import React from 'react';
import './CapabilityItem.css';

interface CapabilityItemProps {
  icon: string;
  title: string;
  description: string;
}

const CapabilityItem: React.FC<CapabilityItemProps> = ({ icon, title, description }) => {
  return (
    <div className="capability-item">
      <div className="capability-icon">{icon}</div>
      <h4>{title}</h4>
      <p>{description}</p>
    </div>
  );
};

export default CapabilityItem;

